var galleryThumbs = new Swiper('.gallery-thumbs', {
  effect: 'coverflow',
  grabCursor: true,
  centeredSlides: true,
clickable: true,
  slidesPerView: '2',  
  coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 50,
        modifier: 6,
        slideShadows : false,
    }, 
thumbs: {
    swiper: galleryThumbs
    }   
  });

// 1️⃣ Create the thumbs slider first
var galleryThumbsNew = new Swiper('.gallery-thumbs-new', {
  slidesPerView: 2,
  watchSlidesProgress: true,
  initialSlide: 1, // ✅ start on second slide
  centeredSlides: true,
  grabCursor: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 50,
    modifier: 6,
    slideShadows: false,
  },
  effect: 'coverflow',
});

  
var galleryTop = new Swiper('.swiper-container.testimonial', {
  direction: 'vertical',
  pagination: {
    clickable: true,
    el: '.swiper-pagination',
    type: 'bullets',
  },
  thumbs: {
    swiper: galleryThumbs
    }
  });

